export default "__VITE_ASSET__e427671f__"